import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Device } from '@rocksoft/shared';

@Component({
  selector: 'era-device-os-update-reset-ui',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './device-os-update-reset.component.html',
})
export class DeviceOsUpdateResetComponent {
  public readonly device = input.required<Device>();
  public readonly resetClicked = output<Device>();

  public onReset() {
    this.resetClicked.emit(this.device());
  }
}
